type SectionTitleProps = {
  eyebrow?: string;
  children: React.ReactNode;
};

export function SectionTitle({ eyebrow, children }: SectionTitleProps) {
  return (
    <div className="mb-5">
      {eyebrow ? <p className="kicker mb-2.5">{eyebrow}</p> : null}
      <h2 className="font-sans text-[26px] font-bold leading-[1.2] tracking-tight text-ink-900">
        {children}
      </h2>
    </div>
  );
}
